/// <amd-module name="Release/DeletedPipelines/ActionCreator" />

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

import { IReleaseService } from "Release/Client/Service/Release";
import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { Actions as DeletedPipelineActions } from "Actions";
import { IDeletedDefinitionProviderData } from "./DeletedPipelinesData";

export class DeletedPipelinesActionCreator {
    public static getKey(): string {
        return "rm-del-pipelines-actions";
    }

    public initialize(): void {
        this._actions = ActionsHubManager.GetActionsHub<DeletedPipelineActions>(DeletedPipelineActions);
    }

    public fetchDeletedPipelines(pageContext: IVssPageContext): void {
        const contributionsService = pageContext.getService<IVssContributionService>("IVssContributionService");

        if (!initialDataFetched) {
            const initialData: IDeletedDefinitionProviderData | undefined = contributionsService.getData(dataProviderContributionId);
            if (initialData) {
                this._actions.fetchDeletedPipelines.invoke({ pipelines: initialData.releaseDefinitions, isLoading: false });
                initialDataFetched = true;
                return;
            }
        }

        this._actions.fetchDeletedPipelines.invoke({ pipelines: [], isLoading: true });
        contributionsService.getDataAsync<IDeletedDefinitionProviderData>(dataProviderContributionId, undefined, true, "0000000d-0000-8888-8000-000000000000")
            .then((data: IDeletedDefinitionProviderData) => {
                this._actions.fetchDeletedPipelines.invoke({ pipelines: data.releaseDefinitions, isLoading: false });
            });
    }

    public undeletePipeline(
        pageContext: IVssPageContext,
        pipelineId: number,
        pipelineName: string,
        comment: string,
        onPipelineUndeleted?: (pipelineId: number, pipelineName: string) => void,
        onUndeleteFailed?: (pipelineId: number, pipelineName: string, error: any) => void): void {
        pageContext.getService<IReleaseService>("IReleaseService").undeleteReleaseDefinition(pipelineId, comment)
            .then(() => {
                this._actions.handleUndelete.invoke(pipelineId);
                if (onPipelineUndeleted) {
                    onPipelineUndeleted(pipelineId, pipelineName);
                }
            }, (error) => {
                if (onUndeleteFailed) {
                    onUndeleteFailed(pipelineId, pipelineName, error);
                }
            });
    }

    private _actions: DeletedPipelineActions;
}

const dataProviderContributionId = "ms.vss-releaseManagement-web.deleted-definitions-data-provider";
let initialDataFetched = false;